import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core'
import { SidebarService } from '../services/sidebar.service'
import { NavbarService } from '../services/navbar.service'
import { Router } from '@angular/router'
import { JobalarmService } from 'src/app/content/general/monitoring/alarm/services/jobalarm.service'
import { STORAGE_USER, STORAGE_USER_LOGIN } from 'src/app/app-settings'
import { PaymentNotificationService } from 'src/app/service/paymentNotfication/payment-notification.service'
import { interval } from 'rxjs'
import { DatePipe } from '@angular/common'
import { IconImageService } from 'src/app/shared/services/icon-image.service'
import { User } from 'src/app/login/models/user'

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  public userBarIsHidden: boolean = true
  hotelId: string
  organizationId: string
  siteSoftwareUrl: string
  userEmail: string
  isHidden = false
  hidePhoneItems = false
  badge: String = '0'
  paymentErrorcounter: string = '0'
  currentDate: Date
  todayDate: string
  user: any
  maxNameLength = 10
  maxEmailLength = 20

  toggleDashboard: boolean = false
  togglePayment: boolean = false
  toggleSupport: boolean = false

  @ViewChild('userMenuPanel') menu: ElementRef
  @ViewChild('collapsedToggle') imgButton: ElementRef
  @ViewChild('arrowToggle') arrowButton: ElementRef

  constructor(
    public iconService: IconImageService,
    public sidebarService: SidebarService,
    public navbarService: NavbarService,
    public router: Router,
    private jobAlarmService: JobalarmService,
    public paymentNotificationService: PaymentNotificationService,
    private datePipe: DatePipe,
    private renderer: Renderer2,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menu?.nativeElement.contains(e.target) && !this.imgButton?.nativeElement.contains(e.target) && !this.arrowButton?.nativeElement.contains(e.target)) {
        this.userBarIsHidden = true
      }
    })
  }

  ngOnInit(): void {
    this.jobAlarmService.getJobStatusWithDetails()
    this.getUser()
    this.currentDate = new Date()
    this.todayDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd')
    this.paymentNotificationService.getPaymentErrors(this.todayDate).subscribe((p) => (this.paymentErrorcounter = p))
    interval(600000).subscribe(() => {
      this.paymentNotificationService.getPaymentErrors(this.todayDate).subscribe((p) => (this.paymentErrorcounter = p))
    })
  }

  truncateText(text: string, maxLength: number): string {
    if (!text) return ''
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
  }

  isCritical(): boolean {
    return this.jobAlarmService.doContainCritical
  }

  isWarning(): boolean {
    return this.jobAlarmService.doContainWarning
  }

  toggleSidebar(): void {
    this.sidebarService.toggleSidebar()
  }

  goToGeneral() {
    this.router.navigate([`/main/general`])
  }

  getUser(): void {
    this.userEmail = localStorage.getItem(STORAGE_USER_LOGIN)
    this.user = JSON.parse(localStorage.getItem(STORAGE_USER))
  }

  home() {
    this.router.navigate(['/main/general'])
  }

  public toggleUserBar(): void {
    this.userBarIsHidden = !this.userBarIsHidden
  }
  gotoProfile() {
    var user = JSON.parse(localStorage.getItem(STORAGE_USER))
    var id = user.Id

    this.router.navigate([`/main/profile/${id}`]) //${id}
    this.toggleProfileList()
  }

  toggleProfileList(): void {
    this.isHidden = !this.isHidden
    this.hidePhoneItems = false
  }

  public toggleMoreMenu(menu: string): void {
    switch (menu) {
      case 'dashboard':
        this.toggleDashboard = !this.toggleDashboard
        this.togglePayment = false
        this.toggleSupport = false
        break
      case 'payment':
        this.togglePayment = !this.togglePayment
        this.toggleDashboard = false
        this.toggleSupport = false
        break
      case 'support':
        this.toggleSupport = !this.toggleSupport
        this.togglePayment = false
        this.toggleDashboard = false
        break
      default:
        this.toggleDashboard = false
        this.togglePayment = false
        this.toggleSupport = false
        break
    }
  }

  gotoAgents() {
    this.router.navigate(['/main/general/agents'])
    this.toggleProfileList()
  }
  logout(): void {
    this.navbarService.logout()
  }
  newPassword(): void {
    this.router.navigate(['/main/general/newpassword/'])
    this.toggleProfileList()
  }

  createNew(): void {
    this.router.navigate(['/main/general/createAgent/'])
    this.toggleProfileList()
  }
  goToSiteSoftware(): void {
    this.hotelId = this.router.url.split('/')[6]
    this.organizationId = this.router.url.split('/')[3]
    this.router.navigate([`/main/organizations/${this.organizationId}/hotel/edit/${this.hotelId}/siteSoftware`])
  }
}
